import getApiClient from '@/plugins/api'
const moment = require('moment')

export default {
  changePage: function (page) {
    this.page = page
  },

  loadPix() {
    const self = this;
    const api = getApiClient(self.$root.$store);

    self.$store.commit('startLoading')

    self.searchParams.page = self.page
    self.searchParams.itemsPerPage = self.perPage

    api.get('pix', {
      params: self.searchParams
    })
      .then((result) => {
        self.pix = result.data['hydra:member']
        self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  openPixDetails: function(pix) {
    this.pixDetails = pix
    this.showPixDetails = true
  }
}
